module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "menu.5d9374a3.svg";